export const RECRUITING_SOURCING_SEARCH = 'RECRUITING_SOURCING_SEARCH'; // = RECRUITING_SOURCING_READ
export const RECRUITING_SOURCING_SAVE = 'RECRUITING_SOURCING_SAVE';
export const RECRUITING_SOURCING_DELETE = 'RECRUITING_SOURCING_DELETE';
